module.exports = __webpack_public_path__ + "media/No_vechicle_in_front.6d02f1be.mp4";